import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { BcConfigService } from 'common/config/provider';
import { CoolLocalStorage } from '@angular-cool/storage';

@Injectable()
export class TranslationLoaderService {
  public preferredLanguageKey = 'bold360PreferredLanguage';
  private _defaultLanguage = 'en-US';

  constructor(private translate: TranslateService, private localStorage: CoolLocalStorage, private config: BcConfigService) {
  }

  loadTranslations(): Promise<void> {
    let languageKey;
    let storedLanguageKey: string = this.localStorage.getItem(this.preferredLanguageKey);

    if (!storedLanguageKey) {
      this.localStorage.setItem(this.preferredLanguageKey, this._defaultLanguage);
      storedLanguageKey = this._defaultLanguage;
    }

    const lang = this.config.current.languages.filter(value => value.key === storedLanguageKey);

    if (lang && lang.length > 0) {
      languageKey = storedLanguageKey;
    } else {
      languageKey = this._defaultLanguage;
    }
    this.translate.setDefaultLang(this._defaultLanguage);
    return this.translate.use(languageKey).toPromise();
  }
}
